import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import {
	DataSecurityWithIssuerTct,
	DayCountConvention,
	SecurityInterestDefinitionPrincipal,
} from '@dealstack/shared/lib/generated';
import { TranslateFunction } from './mechanism/i18n/i18nHooks.types';

export const getDayCountConventionTranslation = (
	tCommonUI: TranslateFunction<I18Namespaces.COMMON_UI>,
	dayCountConvention?: DayCountConvention
) => {
	if (!dayCountConvention) {
		return;
	}

	switch (dayCountConvention) {
		case DayCountConvention.ACTUAL_ACTUAL_ISDA:
			return tCommonUI('dayCountConvention.actualActualISDA');
		case DayCountConvention.THIRTY_360_ISDA:
			return tCommonUI('dayCountConvention.thirty360ISDA');
		case DayCountConvention.THIRTY_365_ISDA:
			return tCommonUI('dayCountConvention.thirty365ISDA');
		case DayCountConvention.ACTUAL_365_FIXED:
			return tCommonUI('dayCountConvention.actual365Fixed');
		default:
			return dayCountConvention;
	}
};
export const getSecurityPrincipalTranslation = (
	tCommonUI: TranslateFunction<I18Namespaces.COMMON_UI>,
	principal?: SecurityInterestDefinitionPrincipal
) => {
	if (!principal) {
		return;
	}

	switch (principal) {
		case SecurityInterestDefinitionPrincipal.ISSUE_COST_PER_UNIT:
			return tCommonUI('principal.issue_cost_per_unit');
		case SecurityInterestDefinitionPrincipal.VALUE_PER_UNIT:
			return tCommonUI('principal.value_per_unit');
		case SecurityInterestDefinitionPrincipal.VALUE_FOR_TOTAL_ISSUE:
			return tCommonUI('principal.value_per_total_issue');
		default:
			return principal;
	}
};

export const makeDayCountConventionDropdownOptions = (
	tCommonUI: TranslateFunction<I18Namespaces.COMMON_UI>
) =>
	Object.values(DayCountConvention).map((value) => ({
		value,
		label: getDayCountConventionTranslation(tCommonUI, value),
	}));

export const makeSecurityPrincipalDropdownOptions = (
	tCommonUI: TranslateFunction<I18Namespaces.COMMON_UI>
) =>
	Object.values(SecurityInterestDefinitionPrincipal).map((value) => ({
		value,
		label: getSecurityPrincipalTranslation(tCommonUI, value),
	}));

export const makeSecurityPillOptions = (
	securities: DataSecurityWithIssuerTct[],
	filterFn?: (sec: DataSecurityWithIssuerTct) => boolean
): DropdownOption[] => {
	return securities
		.filter((sec) => (filterFn ? filterFn(sec) : true))
		.map((sec) => {
			const issuerName = sec.issuer.displayName;
			const label = `${issuerName}: ${sec.name} (${sec.currency})`;

			return {
				value: sec.id,
				label,
			};
		});
};

export interface DropdownOption {
	value: string;
	label: string;
}
